import SaveObservacion from '../../shared/componets/SaveObservacion/SaveObservacion';


export interface CreateObservacionInterface{}
const CreateObservacionPage:React.FC<CreateObservacionInterface> = () => {
    return <SaveObservacion titlePage='CREAR OBSERVACION' />;
    };

export default CreateObservacionPage;